import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

const filterE2DynamicDataSchema = z.object({
  strategy_id_equals: z.string().optional(),
  portfolio_id_equals: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterE2DynamicDataSchema = z.infer<
  typeof filterE2DynamicDataSchema
>;

export function FilterE2DynamicData() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "strategy_id_equals",
      label: t(`${Tables.E2_DYNAMIC_DATA}.searchbox.strategy_id_equals`),
      type: "input",
    },
    {
      name: "portfolio_id_equals",
      label: t(`${Tables.E2_DYNAMIC_DATA}.searchbox.portfolio_id_equals`),
      type: "input",
    },
    {
      name: "date",
      type: "dateRange",
      label: "Date",
      from: { name: "date_from" },
      to: { name: "date_to" },
      copy_from_to_when_to_empty: true,
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      columns={2}
      client={Clients.E2}
      schema={filterE2DynamicDataSchema}
      tableName={`${Tables.E2_DYNAMIC_DATA}`}
      fields={fields}
    />
  );
}
